module.exports = __webpack_public_path__ + "img/logo_mobile_store.c8d6be8e.svg";